import { 
  FETCH_BARCODE_DATA_REQUEST,
  FETCH_BARCODE_DATA_SUCCESS,
  FETCH_BARCODE_DATA_FAILURE,
} from "constants/barcode";

const initState = {
  loading: false,
  data: null,
  error: null,
};

const Barcode = (state = initState, action) => {
  switch (action.type) {
    case FETCH_BARCODE_DATA_REQUEST:
      return { ...state, loading: true, error: null, data: null };
    case FETCH_BARCODE_DATA_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case FETCH_BARCODE_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default Barcode;
